module.exports = __webpack_public_path__ + "img/check-icon-grey.74daf051.svg";